import { render } from "./checkbox-group.vue?vue&type=template&id=cfb2adf6"
import script from "./checkbox-group.vue?vue&type=script&lang=js"
export * from "./checkbox-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__